import { Injectable } from '@angular/core';

/**
 * Состояние errorInterceptor между запросами: функциональный интерцептор вызывается заново на
 * каждый запрос и своих полей не держит.
 */
@Injectable({
  providedIn: 'root',
})
export class ErrorAlertStateService {
  /** Алерт о превышении лимита запросов (429) уже на экране — не дублировать его */
  is429AlertActive = false;
}
